
export default {
  middleware: 'guest',
  auth: false,
  head: () => ({
    title: 'Inloggen',
  }),
  computed: {
    state() {
      const chars = 'ABCDEFGHIJKLMNOPQRTSUVWXYZ1234567890';
      let state = '';
      while (state.length < 32) {
        state += chars[Math.floor(Math.random() * chars.length)];
      }
      return state;
    },
    url() {
      const domain = this.$config.azure.tenant_domain;
      const url = new URL(`https://${domain}.b2clogin.com/${domain}.onmicrosoft.com/oauth2/v2.0/authorize`);
      url.searchParams.set('p', this.$config.azure.login_flow);
      url.searchParams.set('client_id', this.$config.azure.client_id);
      url.searchParams.set('redirect_uri', this.$config.azure.redirect_uri);
      url.searchParams.set('scope', 'openid');
      url.searchParams.set('response_type', 'code');
      url.searchParams.set('prompt', 'login');
      url.searchParams.set('state', this.state);

      this.$cookies.set('auth.state', this.state, {
        path: '/auth',
        maxAge: 3600,
      });

      return url.toString();
    },
  },
  mounted() {
    this.$refs.url.click();
  },
};
